import { useTranslation } from 'react-i18next';
import JiraIcon from '../../../assets/images/export-jira-icon.svg';
import { IntegrationAccordion } from '../../../common/components/IntegrationAccordion';
import { ReactNode, useState } from 'react';

type Props = {
  isLoading: boolean;
  isJiraEnabled: boolean;
  isConfigForm: boolean;
  details: ReactNode;
};

export const JiraAccordion = (props: Props) => {
  const { isJiraEnabled, isLoading, details, isConfigForm } = props;
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(isConfigForm);
  const handleClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <IntegrationAccordion
      isExpanded={isExpanded}
      onClick={handleClick}
      isLoading={isLoading}
      isConfigured={isJiraEnabled}
      title={t('integrationList.jiraTitle')}
      subtitle={isConfigForm ? null : t('integrationList.jiraDescription')}
      icon={<JiraIcon height="31" width="31" />}
      details={details}
    />
  );
};
